var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.175 17.3529H20.7C18.6258 17.3529 17.5887 17.3529 16.9444 18.0076C16.3 18.6623 16.3 19.7161 16.3 21.8235L16.3001 28.8088H31.6999L31.7 21.8235C31.7 19.7161 31.7 18.6623 31.0556 18.0076C30.4113 17.3529 29.3742 17.3529 27.3 17.3529H24.825V22.9105L25.5736 22.0231C25.8702 21.6716 26.391 21.6309 26.7369 21.9322C27.0829 22.2335 27.1229 22.7626 26.8264 23.1141L24.6264 25.722C24.4697 25.9078 24.2409 26.0147 24 26.0147C23.7592 26.0147 23.5304 25.9078 23.3736 25.722L21.1736 23.1141C20.8771 22.7626 20.9172 22.2335 21.2631 21.9322C21.6091 21.6309 22.1299 21.6716 22.4264 22.0231L23.175 22.9105V17.3529Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3337 30.4853L31.6663 30.4853C31.61 31.3689 31.4591 31.9353 31.0556 32.3453C30.4113 33 29.3742 33 27.3 33H20.7C18.6258 33 17.5887 33 16.9444 32.3453C16.5409 31.9353 16.39 31.3689 16.3337 30.4853Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2778 14L30.7222 14C33.0848 14 35 16.0117 35 18.4933C35 19.9344 34.3542 21.217 33.35 22.0392L33.35 21.7235C33.3501 20.7561 33.3502 19.869 33.2547 19.1474C33.1496 18.3528 32.9022 17.513 32.2223 16.8222C31.5425 16.1315 30.7159 15.8801 29.9338 15.7733C29.2236 15.6763 28.3506 15.6764 27.3984 15.6765L20.6015 15.6765C19.6493 15.6764 18.7763 15.6763 18.0661 15.7733C17.2841 15.8801 16.4575 16.1315 15.7776 16.8222C15.0978 17.513 14.8504 18.3528 14.7452 19.1474C14.6498 19.869 14.6499 20.756 14.65 21.7235L14.65 22.0392C13.6458 21.2169 13 19.9344 13 18.4933C13 16.0117 14.9152 14 17.2778 14Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawIcon);
export default __webpack_public_path__ + "static/media/withdrawIcon.d3b5a27f7de62426c6940602860d581d.svg";
export { ForwardRef as ReactComponent };